<template>
  <table>
    <tr>
      <th v-for="grade in grades" :key="grade.code">
        <v-checkbox
          class="ma-0 mt-1"
          style="display: inline-block;"
          v-model="allChecked"
          hide-details=""
          :value="grade.code"
          dark
          @click="allCheck(grade.code)"
        >
          <template v-slot:label>
            <p class="ma-0 pa-0 checkbox__label">{{grade.name}}全</p>
          </template>
        </v-checkbox>
      </th>
    </tr>
    <tr v-for="subjectRow in subjectRows" :key="subjectRow[0].subjectCode" >
      <template v-for="row in subjectRow">
        <td
          v-if="row.gradeCode !== '' && row.subjectCode !== ''"
          :key="row.gradeCode + row.subjectCode + (row.shinkenkyu ? 'shinkenkyu' : '')"
          :class="getTdClass(row.subjectCode, row.shinkenkyu ? 'ssk' : row.gradeCode)"
          @click="clickTd(row.subjectCode, row.shinkenkyu ? 'ssk' : row.gradeCode)"
        >
          {{row.shinkenkyu ? '新研究(社会)' : subjects.find(subject => subject.code === row.subjectCode).name}}
        </td>
        <td class="td__empty" v-else :key="row.gradeCode + row.subjectCode + 'empty'"></td>
      </template>
    </tr>
  </table>
</template>

<script>
import config from '@/config'

export default {
  data: () => ({
    allChecked: [],
    subjectRows: [
      [
        { gradeCode: 't1', subjectCode: 'ch1' },
        { gradeCode: 't2', subjectCode: 'ch1' },
        { gradeCode: 't3', subjectCode: 'ch2' }
      ],
      [
        { gradeCode: 't1', subjectCode: 're1' },
        { gradeCode: 't2', subjectCode: 're1' },
        { gradeCode: 't3', subjectCode: 're23' }
      ],
      [
        { gradeCode: 't1', subjectCode: 'ch2' },
        { gradeCode: 't2', subjectCode: 'ch2' },
        { gradeCode: 't3', subjectCode: 'mi' }
      ],
      [
        { gradeCode: 't1', subjectCode: 're23' },
        { gradeCode: 't2', subjectCode: 're23' },
        { gradeCode: 't3', subjectCode: 'sh', shinkenkyu: true }
      ],
      [
        { gradeCode: '', subjectCode: '' },
        { gradeCode: 't2', subjectCode: 'sh', shinkenkyu: true }
      ],
    ]
  }),

  mounted() {
  },

  computed: {
    // 【担当教科】 編集の場合は保持した値をセット
    selected: {
      get() {
        // オブジェクトから配列に変換(storeに格納するとなぜかオブジェクトになる？)
        let selected = this.$store.state.account.selectedSubjectOptions
        if (!selected) return []

        return Object.keys(selected).map(key => selected[key])
      },
      set(payload) {
        // 教科選択状態をstoreに格納
        // 配列のまま格納できないのでオブジェクトに変換する ["ko1", "ei2", "su2"] => {0:"ko1", 1:"ei2", 2:"su2"};
        this.$store.commit("account/setSelectedSubjectOptions", {
          selectedSubjectOptions: payload
        })
      }
    },
    grades() {
      return this.$store.state.master.allGrades
    },
    subjects() {
      return this.$store.state.master.allSubjects.filter(item => Object.values(config.shakaiOptionSubjects).includes(item.code))
    }
  },

  methods: {
    getTdClass(subjectCode, gradeCode) {
      const code = subjectCode+gradeCode;
      return {
        'selected': this.selected.includes(code),
      }
    },

    allCheck(gradeCode) {
      const func = this.allChecked.includes(gradeCode) ? this.add : this.remove;
      this.subjectRows.flat().forEach(row => {
        if (row.gradeCode === gradeCode) {
          // shinkenkyuがある場合は'ssk'サフィックスを追加
          const code = row.shinkenkyu ? row.subjectCode+'ssk' : row.subjectCode+gradeCode;
          this.selected = func(this.selected, code)
        }
      })
      this.selected = func(this.selected, 'sh'+gradeCode)
    },

    clickTd(subjectCode, gradeCode) {
      const code = gradeCode === 'ssk' ? subjectCode+'ssk' : subjectCode+gradeCode;
      const func = this.selected.indexOf(code) == -1 ? this.add : this.remove;
      this.selected = func(this.selected, code)
      // gradeCodeが'ssk'の場合は元の学年コードを探す必要がある
      const originalGradeCode = gradeCode === 'ssk' ?
        this.subjectRows.flat().find(row => row.subjectCode === subjectCode && row.shinkenkyu)?.gradeCode || '' :
        gradeCode;
      this.selected = func(this.selected, 'sh'+originalGradeCode)
      this.confirmAllCheck(originalGradeCode)
    },

    // 全チェック入れる外すのチェック
    confirmAllCheck(gradeCode) {
      const grade = this.grades.find(grade => grade.code === gradeCode);
      // 通常の教科とshinkenkyu教科の両方をカウント
      const selectedCount = this.selected.filter(select => {
        // gradeCodeを含むか、gradeCode+'ssk'を含むかをチェック
        return select.includes(grade.code) && !select.includes('ssk') ||
               select.includes('ssk');
      }).length
      // subjectRowsから該当学年の教科数を計算
      const gradeSubjectCount = this.subjectRows.flat().filter(row =>
        row.gradeCode === gradeCode || (row.gradeCode === gradeCode && row.shinkenkyu)
      ).length;
      const func = selectedCount === gradeSubjectCount ? this.add : this.remove
      this.allChecked = func(this.allChecked, gradeCode)
    },

    add(array, code) {
      array.push(code)
      // 重複は除去して返す
      return [...new Set(array)]
    },

    remove(array, code) {
      const targetIndex = array.indexOf(code);
      if (targetIndex != -1) array.splice(targetIndex, 1);
      return array
    },
  }
}
</script>

<style lang="stylus" scoped>
th
  width 150px
  height 30px
  background-color #6e6e6e
  color white !important
  font-size 14px !important

td
  text-align center
  border 1px solid #dddd
  font-size 14px !important
  height 50px
  transition background-color .3s, transform 0.3s
  cursor pointer

.td__shakai
  font-size: 13px !important;

.td__empty
  border none
  cursor default

.selected
  color #fff
  font-weight bold
  background-color #f67a06
</style>
